/**
 * Component-error filter of the pizza list. A pizza has an error on a component when the
 * evaluation lists it as missing (base component or ordered extra) or as found although
 * the order removed it - the same NOK events the dashboard "Score by component" card counts.
 */
export const COMPONENT_ERROR_PATHS = [
  "evaluation.metadata.components_evaluation.base_components.missing",
  "evaluation.metadata.components_evaluation.extras.missing",
  "evaluation.metadata.components_evaluation.removals.found",
];

/** Search params the pizza list reads once to show the pizzas with a component error. */
export const COMPONENT_ERROR_SEARCH_PARAMS = {
  component: "componentError",
  from: "from",
  to: "to",
};

const escapeRegex = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

/** Mongo condition: the pizza has an error on the component (whole name, case-insensitive). */
export const componentErrorCondition = (component: string) => ({
  $or: COMPONENT_ERROR_PATHS.map((path) => ({
    [path]: { $regex: `^${escapeRegex(component)}$`, $options: "i" },
  })),
});

/** Link to the pizza list showing the pizzas with an error on the component in the period. */
export const getComponentErrorsLink = (
  component: string,
  start: Date,
  end: Date,
) => {
  const params = new URLSearchParams({
    [COMPONENT_ERROR_SEARCH_PARAMS.component]: component,
    [COMPONENT_ERROR_SEARCH_PARAMS.from]: start.toISOString(),
    [COMPONENT_ERROR_SEARCH_PARAMS.to]: end.toISOString(),
  });

  return `/pizzas?${params.toString()}`;
};
